import "../../components/AccountsBills/bills.css";

import React, { useState, useEffect } from "react";
import axios from "axios";

import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";

import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

function SupplierMaster() {
  const [rows, setRows] = useState([
    { id: 1, quantity: 1.0, rate: 0.0, amount: 0.0 },
  ]);

  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        id: rows.length + 1,
        quantity: 1.0,
        rate: 0.0,
        amount: 0.0,
      },
    ]);
  };

  const handleDeleteRow = (id) => {
    setRows(rows.filter((row) => row.id !== id));
  };

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{
            padding: "4rem 1rem 1rem 1rem",
            width: "94%",
            backgroundColor: "#F4F4F4",
          }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  Vendor Details | <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>
                    &gt; Accounts & Finance
                  </span>
                  <span style={{ fontSize: "20px", paddingLeft: "10px" }}>
                    &gt; Purchase
                  </span>
                  <span style={{ fontSize: "20px", paddingLeft: "10px" }}>
                    &gt; Bills
                  </span>
                </h1>
              </div>
              <div style={{ width: "8rem" }}>
                <select
                  className="form-control form-control-bills"
                  name="country"
                >
                  <option value="0">INDIA </option>
                  <option value="1">DUBAI </option>
                </select>
              </div>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
                <h2
                  className="Venderheading"
                  style={{
                    fontSize: "22px",
                    textAlign: "left",
                    paddingLeft: "16px",
                    paddingTop: "7px",
                  }}
                >
                  Details
                </h2>

                <div className="p-4 bg-white shadow-md rounded-lg max-w-4xl mx-auto">
                  <div className="row mb-3">
                    <div className="col-6">
                      <label className="form-label">Vendor Name*</label>
                      <select className="form-control form-control-bills">
                        <option>Select</option>
                      </select>
                    </div>
                    <div className="col-3">
                      <label className="form-label">Bill #</label>
                      <input
                        type="text"
                        className="form-control form-control-bills"
                        placeholder="."
                      />
                    </div>
                    <div className="col-3">
                      <label className="form-label">Lead ID</label>
                      <input
                        type="text"
                        className="form-control form-control-bills"
                        placeholder="Enter"
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-3">
                      <label className="form-label">Due Date</label>
                      <input
                        type="date"
                        id="date"
                        className="form-control form-control-bills"
                      />
                    </div>
                    <div className="col-3">
                      <label className="form-label">Payment Term</label>
                      <select className="form-control form-control-bills">
                        <option>Select</option>
                      </select>
                    </div>
                    <div className="col-6">
                      <label className="form-label">Subject</label>
                      <textarea
                        name="subject"
                        id="subjetBill"
                        className="form-control form-control-bills"
                      ></textarea>
                      {/* <input type="text" className="form-control form-control-bills" placeholder="Enter a subject within 250 characters" /> */}
                    </div>
                  </div>

                  <hr />

                  <div className="row">
                    <div className="col-3">
                      <select className="form-control form-control-bills">
                        <option>At Transaction Level</option>
                      </select>
                    </div>
                  </div>
                </div>

                <h2
                  className="Venderheading"
                  style={{
                    fontSize: "22px",
                    textAlign: "left",
                    paddingLeft: "16px",
                    paddingTop: "7px",
                  }}
                >
                  Item table
                </h2>

                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead className="bg-gray-200 account-bills-thead">
                      <tr className="account-bills-thead-tr">
                        <th
                          className="account-bills-thead-tr-th"
                          style={{ width: "17%" }}
                        >
                          Item Details
                        </th>
                        <th
                          className="account-bills-thead-tr-th"
                          style={{ width: "17%" }}
                        >
                          Account
                        </th>
                        <th
                          className="account-bills-thead-tr-th"
                          style={{ width: "6%" }}
                        >
                          Quantity
                        </th>
                        <th
                          className="account-bills-thead-tr-th"
                          style={{ width: "6%" }}
                        >
                          Rate
                        </th>
                        <th
                          className="account-bills-thead-tr-th"
                          style={{ width: "17%" }}
                        >
                          TAX
                        </th>
                        <th
                          className="account-bills-thead-tr-th"
                          style={{ width: "17%" }}
                        >
                          Customer Details
                        </th>
                        <th
                          className="account-bills-thead-tr-th"
                          style={{ width: "15%" }}
                        >
                          Amount
                        </th>
                        <th className="account-bills-thead-tr-th"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((row, index) => (
                        <tr key={row.id}>
                          <td>
                            <select className="form-control">
                              <option>Select</option>
                            </select>
                          </td>
                          <td>
                            <select className="form-control">
                              <option>Select</option>
                            </select>
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              defaultValue={row.quantity}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              defaultValue={row.rate}
                            />
                          </td>
                          <td>
                            <select className="form-control">
                              <option>Select</option>
                            </select>
                          </td>
                          <td>
                            <select className="form-control">
                              <option>Select</option>
                            </select>
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              defaultValue={row.amount}
                              disabled
                            />
                          </td>
                          <td>
                            <button
                              className="text-red-500 border-none bg-transparent cursor-pointer"
                              onClick={() => handleDeleteRow(row.id)}
                              style={{ width: "100%", color: "red" }}
                            >
                              ✖
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="row">
                  {/* Left Column */}
                  <div className="col-6">
                    <button className="btn btn-primary" onClick={handleAddRow}>
                      Add New Row +
                    </button>
                  </div>

                  {/* Right Column */}
                  <div className="col-6 bg-light p-3 rounded">
                    <div className="d-flex justify-content-between">
                      <span>Taxable Amount</span>
                      <span>0.00</span>
                    </div>
                    <div className="d-flex align-items-center">
                      <span
                        className="d-flex"
                        style={{ flexDirection: "column" }}
                      >
                        Discount{" "}
                        <small className="text-primary">Apply after tax</small>
                      </span>
                      <div className="d-flex" style={{ paddingLeft: "5.5rem" }}>
                        <input
                          type="number"
                          className="form-control w-50"
                          defaultValue="0.00"
                        />
                        <span className="ms-2">%</span>
                      </div>
                    </div>

                    <hr></hr>
                    <div className="d-flex justify-content-between pb-3">
                      <span>CGST [9%]</span>
                      <span>0.00</span>
                    </div>
                    <div className="d-flex justify-content-between pb-5">
                      <span>SGST [9%]</span>
                      <span>0.00</span>
                    </div>
                    <div className="d-flex  align-items-center">
                      <span>Total Tax Amount</span>
                      <div className="d-flex" style={{ paddingLeft: "5.5rem" }}>
                        <input
                          type="number"
                          className="form-control w-50"
                          defaultValue="0.00"
                        />
                        <span className="ms-2">%</span>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <input type="checkbox" className="me-2" /> TDS
                      <input type="checkbox" className="ms-3 me-2" /> TCS
                      <div
                        className="d-flex justify-content-between w-100"
                        style={{ paddingLeft: "5.5rem" }}
                      >
                        <select
                          className="form-control"
                          style={{ width: "35%" }}
                        >
                          <option>Select a Tax</option>
                        </select>
                        <span className="ms-auto">-0.00</span>{" "}
                        {/* Pushes span to the right */}
                      </div>
                    </div>

                    <div
                      className="d-flex justify-content-between"
                      style={{ marginLeft: "-9px" }}
                    >
                      <select className="form-control" style={{ width: "22%" }}>
                        <option>Adjustment</option>
                      </select>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="-"
                        style={{ width: "18%", marginLeft: "40px" }}
                      />
                      <span className="ms-auto">-0.00</span>{" "}
                      {/* Pushes span to the right */}
                    </div>
                    <hr />
                    <div className="d-flex justify-content-between font-weight-bold">
                      <span>Total</span>
                      <span>0.00</span>
                    </div>
                  </div>
                </div>

                <br></br>

                <div className="row">
                  {/* Left Notes Section */}
                  <div className="col-6 bg-light p-3 rounded">
                    <label htmlFor="subjetBill" className="form-label">Notes</label>
                    <textarea
                      name="subject"
                      id="subjetBill"
                      className="form-control form-control-bills"
                    ></textarea>
                  </div>

                  {/* Vertical Divider */}
                  <div className="col-1 d-flex justify-content-center align-items-center bg-light p-3 rounded">
                    <div className="vr"></div>
                  </div>

                  {/* File Upload Section */}
                  <div className="col-5 bg-light p-3 rounded">
                    <label htmlFor="fileInput" className="form-label">Attach File to Bill</label>
                    <input
                      type="file"
                      id="fileInput"
                      className="form-control form-control-bills form-control-bills-new"  
                    />
                  </div>
                </div>


                <div style={{ textAlign: "end", paddingTop: "20px" }}>
                  <button className="text-red-500 border-none cursor-pointer" style={{ background: '#5B489D', color: 'white' }}>
                    Upload
                  </button>
                </div>
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SupplierMaster;
